import { INFO_BY_CHAIN } from '@pulsex/chains'
import { GraphQLClient } from 'graphql-request'

export const infoClientWithChain = (chainId: number, protocol: string) => {
  if (INFO_BY_CHAIN[chainId][protocol]) {
    return new GraphQLClient(INFO_BY_CHAIN[chainId][protocol].url)
  }
  return undefined
}
